










































import Vue, { PropType } from 'vue';
import { ApptSummary } from '@/types';
import { isApptEditable, isMobile } from '@/util';
import InfoIcon from '@/assets/icons/InfoIcon.vue';
import { EventType } from '@/constants';

export default Vue.extend({
  name: 'SummaryListItem',
  components: {
    InfoIcon
  },
  data () {
    return {
      isVisibleContactModal: false
    };
  },
  props: {
    meeting: {
      type: Object as PropType<ApptSummary>,
      required: true
    },
    selectedContactModal: {
      type: String,
      required: true
    }
  },
  methods: {
    isAppointmentEditable (appointment: ApptSummary) {
      return isApptEditable(appointment.startDate, appointment.isFromFeedAppointment, appointment.customerCanScheduleAppointment);
    },
    showAppointmentDetails (appointment: ApptSummary) {
      this.$emit(EventType.SHOW_DETAILS, appointment.appointmentId);
    },
    showContactInfoModal (appointmentId: string) {
      this.isVisibleContactModal = !this.isVisibleContactModal;
      this.$emit('openedModal', this.isVisibleContactModal ? appointmentId : '');
    },
    isMobileDevice () {
      const isIpad = navigator.userAgent.match(/iPad/i) != null;
      return isMobile() || isIpad;
    }
  }
});
